import React from 'react';
import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import cx from "classnames"


const Select = ({ placeholder, onChange, clearable = false, className, options, value, input }) => {
    //TODO nullable et clearable
    const [selected, setSelected] = useState(value?.value)
    function handleChange(value)
    {
        if(input){
            input.onChange(value)
        }
        if(onChange) {
            onChange(value)
        }
        setSelected(value)
    }

    return (
        <Listbox value={selected} onChange={handleChange}>
            {({ open }) => (
                <>
                    <div className="relative mt-2">
                        <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                            <span className="block truncate">{selected ? selected : placeholder}</span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                          </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                {options.map((option, index) => (
                                    <Listbox.Option
                                        key={index}
                                        className={({ active }) =>
                                            cx('relative cursor-default select-none py-2 pl-3 pr-9', {
                                                    'bg-orange-600 text-white' : active,
                                                    'text-gray-900' : !active,
                                                }
                                            )
                                        }
                                        value={option.value}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <span className={cx('block truncate', {
                                                    'font-semibold' : selected,
                                                    'font-normal' : !selected
                                                }, )}>
                                                  {option.label}
                                                </span>
                                                {selected ? (
                                                    <span
                                                        className={cx('absolute inset-y-0 right-0 flex items-center pr-4', {
                                                            'text-white' : active ,
                                                            'text-indigo-600' : !active,
                                                        }
                                                        )}
                                                    >
                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}

export default Select;